/**
 * Copyright (c) 2018 Jayjeet Chakraborty.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 *
 * @description Describes urls as constants
 * @constant
 * @type {string}
 * @default
 *
 */
export const AUTHORIZATION_URL = 'https://api.codechef.com/oauth/authorize?'
export const TOKEN_URL = 'https://api.codechef.com/oauth/token'
